import React, { useContext, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import OrderTable from "./OrderTable";
import { ToastContainer } from "react-toastify";

const DiningSection = ({
  orders,
  onRowClick,
  onCancel,
  onCollectCash,
  updateOrderStatus,
  getNewOrders,
  getOrderHistory,
  startDate,
  endDate,
  getTimeElapsed,
  getDiningStatusLabel,
  getOrderDetails,
}) => {
  const [diningModalOrder, setDiningModalOrder] = useState(null);
  const [cashModalOrder, setCashModalOrder] = useState(null);
  const [paymentMode, setPaymentMode] = useState("cod");
  const [collectedBy, setCollectedBy] = useState("Restaurant");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const { userID } = useContext(GlobalContext);

  const handleDiningReady = async () => {
    if (!diningModalOrder) return;

    const payload = {
      userid: userID,
      orderid: diningModalOrder.orderid,
      productid: "",
      status: "ready_for_dinning",
      time: "",
      payment: "",
    };

    await updateOrderStatus(payload);

    setDiningModalOrder(null);

    getNewOrders(startDate, endDate);
    getOrderHistory(startDate, endDate);
  };

  const handleCollectCash = async () => {
    if (!cashModalOrder) return;

    const payload = {
      userid: userID,
      orderid: cashModalOrder.orderid,
      productid: "string",
      status: "cash_collected",
      time: "string",

      payment: paymentMode === "cod" ? "cod" : "Card",
      paymentCollectedBy: collectedBy,
      remarks: collectedBy,
    };

    await updateOrderStatus(payload);

    setCashModalOrder(null);

    getNewOrders(startDate, endDate);
    getOrderHistory(startDate, endDate);
  };

  return (
    <>
    <ToastContainer/>
      <table className="w-full text-sm montserrat-font-1">
        <thead className="bg-green-100 sticky top-0 z-10 montserrat-font-1">
          <tr>
            <th className="p-4 text-left">Order ID</th>
            <th className="p-4 text-left">Date</th>
            <th className="p-4 text-left">Time</th>
            <th className="p-4 text-left">Customer</th>
            <th className="p-4 text-left">Status</th>
            <th className="p-4 text-left">Action</th>
            <th className="p-4 text-left">Print</th>
          </tr>
        </thead>

        <tbody>
          {orders.map((order, index) => {
            const statusInfo = getDiningStatusLabel(order);
            const timeElapsed = getTimeElapsed(order.order_date, order.status);

            return (
              <React.Fragment key={order.orderid}>
                <tr
                  key={order.orderid}
                  className="border-t hover:bg-gray-50 cursor-pointer"
                  onClick={async () => {
                    if (selectedOrder === order.orderid) {
                      setSelectedOrder(null);
                      return;
                    }

                    setSelectedOrder(order.orderid);
                    setDetailsLoading(true);

                    const data = await getOrderDetails(order.orderid);
                    setOrderDetails(data);

                    setDetailsLoading(false);
                  }}
                >
                  {/* ORDER ID */}
                  <td className="p-4">
                    <div className="text-xs text-gray-500">
                      ORD ID: {order.orderid}
                    </div>
                    {order.daily_order_id && (
                      <div className="font-bold text-sm">
                        {order.daily_order_id}
                      </div>
                    )}
                  </td>

                  {/* DATE */}
                  <td className="p-4">
                    <div>{order.order_date?.split(" ")[0]}</div>
                    <div className="text-xs text-gray-500">
                      {order.order_date?.split(" ")[1]}{" "}
                      {order.order_date?.split(" ")[2]}
                    </div>
                  </td>

                  {/* TIME */}
                  <td className="p-4">
                    <span
                      className={`text-xs px-2 py-1 rounded text-white ${
                        timeElapsed.isLate ? "bg-red-600" : "bg-gray-500"
                      }`}
                    >
                      {timeElapsed.time}
                    </span>
                  </td>

                  {/* CUSTOMER */}
                  <td className="p-4">
                    {order.customer_name && <div>{order.customer_name}</div>}
                    <div className="text-xs text-gray-500">
                      {order.customer_mobile}
                    </div>
                  </td>

                  {/* STATUS */}
                  <td className="p-4">
                    <span
                      className={`px-3 py-1.5 rounded-full text-sm font-semibold bg-green-50 ${statusInfo.className}`}
                    >
                      {statusInfo.label}
                    </span>
                  </td>

                  {/* ACTION */}
                  <td className="p-4">
                    {order.status === "paid" ? (
                      <div className="flex gap-2">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setDiningModalOrder(order);
                          }}
                          className="border border-blue-500 text-blue-600 px-3 py-1 rounded text-xs"
                        >
                          Dispatch Order
                        </button>

                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onCancel(order.orderid);
                          }}
                          className="border border-red-500 text-red-600 px-3 py-1 rounded text-xs"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setCashModalOrder(order);
                        }}
                        className="bg-green-600 text-white px-3 py-1 rounded text-xs"
                      >
                        Collect Cash
                      </button>
                    )}
                  </td>

                  {/* PRINT */}
                  <td className="p-4 space-x-2">
                    <button className="border px-3 py-1 rounded text-blue-600 text-xs">
                      Print
                    </button>
                    <button className="border px-3 py-1 rounded text-blue-600 text-xs">
                      Direct
                    </button>
                  </td>
                </tr>

                {selectedOrder === order.orderid && (
                  <tr>
                    {detailsLoading ? (
                      <td colSpan="7" className="text-center p-4">
                        Loading...
                      </td>
                    ) : (
                      <OrderTable
                        orderDetails={orderDetails}
                        selectedDeliveryPerson={null}
                        activeTab="current"
                      />
                    )}
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>

      {/* ───────── Dining Button MODAL ───────── */}
      {diningModalOrder && (
        <div className="fixed inset-0 montserrat-font-1 z-[9999] bg-black bg-opacity-40 flex justify-center items-center">
          <div
            className="bg-white rounded-lg w-[500px] montserrat-font-1 shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="flex justify-between items-center px-4 py-3 border-b">
              <h2 className="text-lg font-medium">Dining</h2>
              <button
                onClick={() => setDiningModalOrder(null)}
                className="text-gray-500 hover:text-black text-xl"
              >
                ×
              </button>
            </div>

            {/* BODY */}
            <div className="px-4 py-5 montserrat-font-1">
              <p className="font-semibold text-gray-800">Dining Order</p>
              <p className="text-sm text-gray-500 mt-1">
                Order will be served in the restaurant.
              </p>
            </div>

            {/* FOOTER */}
            <div className="flex justify-end gap-2 px-4 py-3 border-t">
              <button
                onClick={() => setDiningModalOrder(null)}
                className="px-4 py-1.5 border rounded text-sm"
              >
                Close
              </button>

              <button
                onClick={handleDiningReady}
                className="px-4 py-1.5 border border-blue-500 text-blue-600 rounded text-sm"
              >
                Ready for Dining
              </button>
            </div>
          </div>
        </div>
      )}

      {/* collect cash button model */}

      {cashModalOrder && (
        <div className="fixed inset-0 z-[9999] montserrat-font-1 bg-black bg-opacity-40 flex justify-center items-center">
          <div
            className="bg-white w-[500px] rounded-lg shadow-lg montserrat-font-1"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="flex justify-between items-center px-4 py-3 border-b">
              <h2 className="text-lg font-semibold">Cash Collection</h2>
              <button onClick={() => setCashModalOrder(null)}>✕</button>
            </div>

            {/* BODY */}
            <div className="px-4 py-5 text-center">
              <div className="text-3xl font-bold text-green-600">
                ₹{Number(cashModalOrder?.pay_amount || 0).toFixed(2)}
              </div>
              <p className="text-sm text-gray-500 mt-1">
                Order Amount to Collect
              </p>

              {/* Payment Mode */}
              <div className="mt-6 text-left">
                <p className="font-medium mb-2">Payment Mode</p>

                <div className="flex gap-2">
                  <button
                    onClick={() => setPaymentMode("cod")}
                    className={`px-4 py-2 rounded border ${
                      paymentMode === "cod"
                        ? "bg-blue-600 text-white"
                        : "border-blue-500 text-blue-600"
                    }`}
                  >
                    Cash
                  </button>

                  <button
                    onClick={() => setPaymentMode("card")}
                    className={`px-4 py-2 rounded border ${
                      paymentMode === "card"
                        ? "bg-blue-600 text-white"
                        : "border-blue-500 text-blue-600"
                    }`}
                  >
                    Card Payment
                  </button>
                </div>
              </div>

              {/* Collected By */}
              <div className="mt-6 text-left montserrat-font-1">
                <p className="font-medium mb-2">Collected By</p>

                <div className="flex gap-2">
                  <button
                    onClick={() => setCollectedBy("Restaurant")}
                    className={`px-4 py-2 rounded border ${
                      collectedBy === "Restaurant"
                        ? "bg-blue-600 text-white"
                        : "border-gray-300"
                    }`}
                  >
                    Restaurant
                  </button>

                  <button
                    disabled
                    className="px-4 py-2 rounded border text-gray-400"
                  >
                    Delivery Partner
                  </button>
                </div>
              </div>
            </div>

            {/* FOOTER */}
            <div className="flex justify-end gap-2 px-4 py-3 border-t" montserrat-font-1>
              <button
                onClick={() => setCashModalOrder(null)}
                className="px-4 py-1.5 border rounded"
              >
                Cancel
              </button>

              <button
                onClick={handleCollectCash}
                className="px-4 py-1.5 bg-green-600 text-white rounded"
              >
                Confirm & Collect ₹
                {Number(cashModalOrder?.pay_amount || 0).toFixed(2)}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DiningSection;
